import React from 'react';
import {Box, CircularProgress} from '@mui/material';

export const LoadingIndicator = () => {
    return <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        mx: 'auto',
        backgroundColor: '#000',
    }}>
        <CircularProgress size="4rem" sx={{color: "#FFFFFF"}}/>
    </Box>
}
